import { IAccess, IServiceStatus } from "@nju/data-access-portal-product";
import { differenceInCalendarDays } from "@nju/utils";

export function getFtthServiceStatus(
  access?: IAccess,
): IServiceStatus["ftthServiceStatus"] {
  if (!access) {
    return;
  }

  const ftthServiceStatus = access.status;
  const daysToTermination = differenceInCalendarDays(access?.terminationDate);

  if (
    ftthServiceStatus === "Disconnected" &&
    daysToTermination &&
    daysToTermination < 31
  ) {
    return "AlmostTerminated";
  }

  return ftthServiceStatus;
}
